import AjaxUtil from '../../axios/axios';

export const loadHtml = async(htmlCode) => {
    try {
        return  await AjaxUtil.fetchData(`/assets/${htmlCode}`, {}, false, { method: 'get', showError: true} );
    } catch (error) {
        throw error;
    }
}